"use strict";

module.exports = /*@ngInject*/function ($window) {
  var keyName = 'inspect-preference';
  var service = {
    get: function get() {
      var value = $window.localStorage.getItem(keyName);
      return value ? JSON.parse(value) : {};
    },
    save: function save(key, value) {
      var preference = service.get();
      preference[key] = value;
      $window.localStorage.setItem(keyName, JSON.stringify(preference));
    },
    clear: function clear(key) {
      var preference = service.get();
      preference[key] = null;
      $window.localStorage.setItem(keyName, JSON.stringify(preference));
    }
  };
  return service;
};